import React from 'react'
import { Route } from 'react-router-dom'
import { RoleSysApiKey } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { SysApiKeysPage } from './sys-api-keys-page'

// /admin/api-keys: staff oversight of every organization's API keys. The
// route itself is gated by SYS_API_KEY read (not only its sidebar entry),
// so a typed address without it says so instead of a page whose every read
// is refused.
export const LayoutSysApiKeys = () =>
  <Route path="/admin/api-keys">
    <RoleSysApiKey accessRead fallback={<NoAccess what="API key oversight" />}>
      <SysApiKeysPage />
    </RoleSysApiKey>
  </Route>
